import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "roofBox"
const RoofBoxIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.497 4h6.006A3.001 3.001 0 0 1 18.5 7v2.009c0 .548-.456.991-1.003.991H7.503A1.002 1.002 0 0 1 6.5 9.009V7c0-1.657 1.342-3 2.997-3ZM7 23a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm11 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM6 18c0-1 0-5 3.5-5h6c3.5 0 3.5 4 3.5 5H6Zm10-7H9c-2.36 0-4.039 1.82-4.882 4.539a1.75 1.75 0 1 0-.59 3.447c-.018.333-.028.671-.028 1.014v4h17.972l.028-4c0-.343-.01-.681-.028-1.014a1.75 1.75 0 1 0-.59-3.447C20.039 12.82 18.36 11 16 11Z"
          />
        </svg>
      }
    </span>
  )
}
export default RoofBoxIcon
